import React, { useEffect } from "react";
import { useAnswers } from '@ignitesales/neuro-application';


const ReasonForVisit = (props) => {
  
  const { 
    renderAllQuestions,
    renderQuestion,
    questionGroup
  } = props;

  const { answers } = useAnswers();

  useEffect(() => {

    const question = questionGroup?.questions?.find((question) => question.appkey === "preferences_reasonForVisit");
    
    if(question) {
      question.answers.forEach((answer, index) => {
        const key = answer.key;
        const elements = document.querySelectorAll(`.checkboxRadioNative__checkbox`);
        elements[index].classList.add(`${key}__answer`);

        elements[index].classList.forEach((className) => {
          if(className.includes('priority')) {
            elements[index].classList.remove(className);
          }
        });
      });
    }


    const reasonForVisitAnswer = answers?.preferences_reasonForVisit?.value || [];
    
    if(!!reasonForVisitAnswer.length) {
      reasonForVisitAnswer.forEach((answer, index) => {
        const order = index + 1;
        const element = document.querySelector(`.${answer}__answer`);
        if(element) {
          element.classList.add(`priority__${order}`);
        }
      });
    }


  }, [answers]);



  return (
    <>
      <section>
        {renderAllQuestions()}
      </section>
    </>
  );
}

export default ReasonForVisit;